import React, { useEffect, useState } from "react";
import styled, { keyframes } from "styled-components";
import { RACE_DATE_ISO, RACE_DATE_LABEL } from "../data/EventConfig";

const Section = styled.section`
  position: relative;
  padding: 5rem 1.5rem 6rem;
  background: linear-gradient(180deg, #0a2a4a 0%, #133b66 100%);
  color: #fff;
  text-align: center;
  overflow: hidden;
`;

const Eyebrow = styled.p`
  text-transform: uppercase;
  letter-spacing: 0.18em;
  font-size: 0.85rem;
  color: #ffce2d;
  margin-bottom: 0.75rem;
  font-weight: 700;
`;

const Heading = styled.h2`
  font-size: clamp(1.6rem, 4vw, 2.4rem);
  font-weight: 800;
  margin-bottom: 0.4rem;
`;

const DateLine = styled.p`
  font-size: clamp(1rem, 2.5vw, 1.2rem);
  opacity: 0.9;
  margin-bottom: 2.5rem;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 1rem;
  max-width: 720px;
  margin: 0 auto;

  @media screen and (max-width: 480px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 0.75rem;
  }
`;

const pop = keyframes`
  0% { transform: scale(1); }
  50% { transform: scale(1.05); }
  100% { transform: scale(1); }
`;

const Tile = styled.div`
  background: rgba(255, 255, 255, 0.07);
  border: 1px solid rgba(255, 206, 45, 0.25);
  border-radius: 18px;
  padding: 1.25rem 0.5rem;
  backdrop-filter: blur(8px);
`;

const Number = styled.div`
  font-size: clamp(2rem, 7vw, 3.6rem);
  font-weight: 800;
  color: #ffce2d;
  line-height: 1;
  font-variant-numeric: tabular-nums;
  animation: ${pop} 0.4s ease;
`;

const Label = styled.div`
  margin-top: 0.5rem;
  text-transform: uppercase;
  letter-spacing: 0.12em;
  font-size: 0.75rem;
  font-weight: 600;
  opacity: 0.85;
`;

const Live = styled.div`
  margin-top: 2rem;
  font-size: 1.1rem;
  font-weight: 700;
  color: #ffce2d;
`;

const pad = (n) => String(n).padStart(2, "0");

const calc = (target) => {
  const diff = new Date(target).getTime() - Date.now();
  if (diff <= 0) return null;
  const days = Math.floor(diff / (1000 * 60 * 60 * 24));
  const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
  const minutes = Math.floor((diff / (1000 * 60)) % 60);
  const seconds = Math.floor((diff / 1000) % 60);
  return { days, hours, minutes, seconds };
};

const Countdown = () => {
  const [time, setTime] = useState(() => calc(RACE_DATE_ISO));

  useEffect(() => {
    const id = setInterval(() => setTime(calc(RACE_DATE_ISO)), 1000);
    return () => clearInterval(id);
  }, []);

  return (
    <Section id="countdown">
      <Eyebrow>Numărătoarea inversă</Eyebrow>
      <Heading>Până la cursa de rățuște</Heading>
      <DateLine>{RACE_DATE_LABEL} · Ziua Internațională a Copilului</DateLine>
      {time ? (
        <Grid>
          <Tile>
            <Number key={time.days}>{time.days}</Number>
            <Label>Zile</Label>
          </Tile>
          <Tile>
            <Number key={time.hours}>{pad(time.hours)}</Number>
            <Label>Ore</Label>
          </Tile>
          <Tile>
            <Number key={time.minutes}>{pad(time.minutes)}</Number>
            <Label>Minute</Label>
          </Tile>
          <Tile>
            <Number key={time.seconds}>{pad(time.seconds)}</Number>
            <Label>Secunde</Label>
          </Tile>
        </Grid>
      ) : (
        <Live>🦆 Cursa este astăzi! Te așteptăm pe Bega.</Live>
      )}
    </Section>
  );
};

export default Countdown;
